import React from 'react';

import CommonStrings from 'resources/common-strings';

export default class NoProjectionsHelpText extends React.Component {
    render() {
        return (
            <div className="no-projections-help-text">
                <p>{CommonStrings.comparisonsProjectionsNoProjectionsHelp.initialText}</p>
                <p>{CommonStrings.comparisonsProjectionsNoProjectionsHelp.secondParagraph}</p>
            </div>
        );
    }
}
